import webBiLogger from '@wix/web-bi-logger';
import { getSessionId } from '../../utils/env/getSessionId';

export const bi = webBiLogger.factory().updateDefaults({
  sessionId: getSessionId(),
  endpoint: 'media-manager-g6',
});
